import { tv } from '~/utils/tv'

export const inputTextActionsVariants = tv({
  base: `
    group flex w-[100%] items-center justify-between gap-onepulse py-threepulse duration-100 ease-in
    bg-forms-filled ring-forms-border-filled ring-quarterpulse overflow-hidden
    focus-within:ring-halfpulse focus-within:bg-forms-fill-focused min-w-[calc(var(--sizing-huge)_+_var(--sizing-tiny))]
    `,
  variants: {
    size: {
      md: 'h-medium rounded-form px-twopulse',
      ml: 'h-mediumlarge rounded-form px-threepulse',
      lg: 'h-large rounded-form px-threepulse',
      xl: 'h-extralarge rounded-largecontainer px-threepulse',
    },
    readOnly: {
      true: '',
    },
    hasError: {
      true: '',
    },
    filled: {
      true: '',
    },
    active: {
      true: '',
    },
    disabled: {
      true: 'cursor-not-allowed ring-forms-border-disabled ring-quarterpulse',
    },
  },
  compoundVariants: [
    {
      readOnly: false,
      disabled: false,
      hasError: false,
      class: `
        [&:not(:focus-within)]:has-[:placeholder-shown]:bg-forms-fill
        [&:not(:focus-within)]:has-[:placeholder-shown]:hover:bg-forms-fill-hovered
      `,
    },
    {
      hasError: false,
      readOnly: false,
      disabled: false,
      class: `
          focus-within:ring-action-border-focused hover:ring-halfpulse
          [&:not(:focus-within)]:has-[:placeholder-shown]:ring-forms-border
          [&:not(:focus-within)]:has-[:placeholder-shown]:hover:ring-forms-border-hovered
          [&:not(:focus-within)]:has-[:placeholder-shown]:ring-none
        `,
    },
    {
      readOnly: true,
      disabled: false,
      class:
        'cursor-not-allowed bg-forms-fill-readonly ring-forms-border-readonly ring-quarterpulse',
    },
    {
      hasError: true,
      filled: true,
      active: false,
      class: 'bg-forms-fill-error ring-forms-border-error hover:ring-halfpulse',
    },
    {
      hasError: true,
      active: true,
      class:
        'bg-forms-fill-error ring-forms-border-error ring-halfpulse hover:bg-forms-fill-error hover:ring-halfpulse',
    },
    {
      hasError: true,
      filled: false,
      active: false,
      class:
        'bg-forms-fill ring-forms-border-error hover:bg-forms-fill-hovered hover:ring-bg-forms-hovered hover:ring-halfpulse',
    },
  ],
  defaultVariants: {
    size: 'ml',
    isFocused: false,
    hasError: false,
    readOnly: false,
    disabled: false,
  },
})
